export default {
  created() {
    // Per-instance, non-reactive registry of LD change listeners so we can
    // detach them on teardown. Keyed by the component property name passed to
    // getFlagRealtimeValue (mirroring the unsubscribe API).
    this._ldFlagListeners = Object.create(null)
  },

  beforeDestroy() {
    if (!this._ldFlagListeners) return
    for (const propertyToUpdate of Object.keys(this._ldFlagListeners)) {
      this.unsubscribeFlagRealtimeValue(propertyToUpdate)
    }
  },

  methods: {
    async getFlagRealtimeValue(propertyToUpdate, flagKey) {
      const ldClient = await this.$launchDarkly.getClient()

      if (this._isDestroyed || this._isBeingDestroyed) return

      // Detach synchronously when the client is already available (re-subscribe).
      this.unsubscribeFlagRealtimeValue(propertyToUpdate, ldClient)

      const handler = (newFlagValue) => {
        this[propertyToUpdate] = newFlagValue
      }
      const eventName = 'change:' + flagKey

      ldClient.on(eventName, handler)
      this._ldFlagListeners[propertyToUpdate] = { eventName, handler }

      const flagValue = ldClient.variation(flagKey, false)
      this[propertyToUpdate] = flagValue
    },

    unsubscribeFlagRealtimeValue(propertyToUpdate, ldClient = null) {
      const entry = this._ldFlagListeners && this._ldFlagListeners[propertyToUpdate]
      if (!entry) return

      delete this._ldFlagListeners[propertyToUpdate]

      const detach = (client) => {
        if (client && typeof client.off === 'function') {
          client.off(entry.eventName, entry.handler)
        }
      }

      if (ldClient) {
        detach(ldClient)
        return
      }

      // Detach asynchronously since the client may not be ready yet (teardown).
      // Guard against any errors so teardown never throws.
      Promise.resolve(this.$launchDarkly && this.$launchDarkly.getClient())
        .then(detach)
        .catch(() => {})
    },
  },
}
